<template>
  <!--콘텐츠 영역-->
  <div id="sub_area">
    <!--비주얼 영역-->
    <div class="sub_visual CompanyProfile">
      <div class="tit_area">
        <h2 class="tit">FERRUM INFRA</h2>
        <!-- <p class="tit">
          페럼인프라는 지난 10년 동안 골프장 운영/시설물 유지 관리 등 골프장
          운영업체였으나,<br />
          현재는 골프장 운영 및 기업의 구매 효율을 극대화하는 MP(Market place)
          시스템을 통해 전문적이고 체계적인 <br />
          구매 방법론으로 신속하고 안정적인 TOC 관점의 효율적 구매 실현과 구매
          전문가들의 현장 밀착 서비스로 <br />
          기업고객에게 최적화된 구매관리 서버와 친환경 골프코스로 명품 라운딩의
          경험을 선사하는 인프라 전문 기업입니다.
        </p>-->
      </div>

      <img :src="require('./../../assets/img/sub/SUB_01_00.png')" alt="BG" />
    </div>
    <div class="sub_contents">
      <a href="#sub_area" id="top_btn"></a>

      <div class="item">
        <div class="tit">
          <h3 class="fNS-B">DK WAY</h3>
        </div>
        <div class="txt">
          <p>
            <img :src="require('./../../assets/img/sub/01/0102_01234.png')" />
          </p>
        </div>
      </div>

      <div class="item" style="padding-top: 200px;">
        <div class="tit">
          <h3 class="fNS-B">경영방침</h3>
        </div>
        <div class="txt">
          <p>
            <img :src="require('./../../assets/img/sub/01/0102_01.png')" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "Principle.vue",
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/Principle.vue